import { type Add, route as addFileMeta } from '../../../server/http/files/addMeta.no-deps'
import type { FileUploadData } from './FileUploadData'
import type { ApiClient } from '../util/ApiClient'

export const sendFileMeta = async (apiClient: ApiClient, fileUploadData: FileUploadData) => {
    await apiClient.request<Add['Body'], Add['Output']>({
        method: addFileMeta.method,
        route: addFileMeta.pattern,
        body: {
            fileId: fileUploadData.fileId,
            extension: fileUploadData.extension,
            createdAt: fileUploadData.createdAt,
            fileName: fileUploadData.fileName,
            fileSizeInBytes: fileUploadData.fileSizeInBytes,
        },
    })
}
